import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { PrescriptionData } from "@/lib/printer";
import { DiopterSelect, DiopterCylinderSelect, AxisSelect, PDSelect, PHSelect, AddSelect } from "./PrescriptionSelects";

interface PrescriptionFormProps {
  prescription: PrescriptionData;
  onChange: (prescription: PrescriptionData) => void;
}

export function PrescriptionForm({ prescription, onChange }: PrescriptionFormProps) {
  const updateField = <K extends keyof PrescriptionData>(
    field: K,
    value: PrescriptionData[K]
  ) => {
    onChange({ ...prescription, [field]: value });
  };

  return (
    <div className="space-y-4">
      {/* 用途 */}
      <div className="space-y-2">
        <Label>用途</Label>
        <select
          className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          value={prescription.use_for !== undefined && prescription.use_for !== null ? String(prescription.use_for) : ''}
          onChange={(e) => updateField('use_for', e.target.value === '' ? undefined : parseInt(e.target.value, 10))}
        >
          <option value="">请选择</option>
          <option value="0">远用</option>
          <option value="1">近用</option>
        </select>
      </div>

      {/* 验光数据表格 */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b">
              <th className="p-2 text-left"></th>
              <th className="p-2 text-left">SPH</th>
              <th className="p-2 text-left">CYL</th>
              <th className="p-2 text-left">Axis</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="p-2 font-semibold">R</td>
              <td className="p-2">
                <DiopterSelect
                  value={prescription.right_sphere}
                  onChange={(val) => updateField('right_sphere', val)}
                />
              </td>
              <td className="p-2">
                <DiopterCylinderSelect
                  value={prescription.right_cylinder}
                  onChange={(val) => updateField('right_cylinder', val)}
                />
              </td>
              <td className="p-2">
                <AxisSelect
                  value={prescription.right_cylinder_axis}
                  onChange={(val) => updateField('right_cylinder_axis', val)}
                />
              </td>
              
            </tr>
            <tr className="border-b">
              <td className="p-2 font-semibold">L</td>
              <td className="p-2">
                <DiopterSelect
                  value={prescription.left_sphere}
                  onChange={(val) => updateField('left_sphere', val)}
                />
              </td>
              <td className="p-2">
                <DiopterCylinderSelect
                  value={prescription.left_cylinder}
                  onChange={(val) => updateField('left_cylinder', val)}
                />
              </td>
              <td className="p-2">
                <AxisSelect
                  value={prescription.left_cylinder_axis}
                  onChange={(val) => updateField('left_cylinder_axis', val)}
                />
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>

      {/* PD瞳距 */}
      <div className="space-y-2">
        <Label>PD（瞳距）</Label>
        <PDSelect
          value={prescription.right_papillary_distance}
          onChange={(val) => {
            onChange({ ...prescription, right_papillary_distance: val, left_papillary_distance: val });
          }}
        />
      </div>

      {/* PH瞳高 */}
      <div className="space-y-2">
        <Label>PH（瞳高）</Label>
        <PHSelect
          value={prescription.right_ocular_center_height}
          onChange={(val) => {
            onChange({ ...prescription, right_ocular_center_height: val, left_ocular_center_height: val });
          }}
        />
      </div>

      {/* ADD 下加光 */}
      <div className="space-y-2">
        <Label>ADD（下加光）</Label>
        <AddSelect
          value={prescription.right_add}
          onChange={(val) => {
            onChange({ ...prescription, right_add: val, left_add: val });
          }}
        />
      </div>

      {/* 备注 */}
      <div className="space-y-2">
        <Label>备注</Label>
        <Textarea
          value={prescription.notes ?? ''}
          onChange={(e) => updateField('notes', e.target.value || undefined)}
          placeholder="请输入备注信息"
          rows={3}
        />
      </div>
    </div>
  );
}
